"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Variants = void 0;
exports.Variants = {
    Button: {
        Inverted: 'MuiButtonInverted',
        Brand: 'MuiButtonBrand',
    },
    Alert: {
        Inline: 'MuiAlertInline',
        Notification: 'MuiAlertNotification',
    },
};
